import React, { useState } from "react";
import { IQuery, IQueryBuilderContext } from "../../types";
import { AsyncButton, toJSON, useAlert } from "uxp/components";
import { applyCopilot } from "@query-engine-service";
import { prepareQuery } from "@utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackAnalytics } from "../../analytics";
import * as CopilotIcon from '@images/copilot.svg'
import './Copilot.scss';
interface ICopilotProps {
    query: IQuery;
    context: IQueryBuilderContext;
    onQueryChanged: (newQuery: IQuery) => void;
}
export const Copilot: React.FC<ICopilotProps> = (props) => {
    const [expanded, setExpanded] = useState(false);
    const [copilotText, setCopilotText] = useState('');
    const [loading, setLoading] = useState(false);
    const alerts = useAlert();
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            // Perform your custom action here
            runCopilot();
        }
    };

    async function runCopilot() {
        try {
            setLoading(true);
            let r = await applyCopilot(props.context, props.query, copilotText);
            let p = (typeof r?.pipeline == 'object') ? r?.pipeline : toJSON(r?.pipeline || '');
            if (!p) {
                alert('Woops. Looks like that did not work. Try again?');
                trackAnalytics(props.context.uxpContext, 'ai', { message: copilotText, success: false });
                return;
            }
            trackAnalytics(props.context.uxpContext, 'ai', { message: copilotText, success: true });

            if (p.steps && p.sources) {
                props.onQueryChanged(await prepareQuery(props.context, p));
                setCopilotText('');
            } else {
                alert('Hm... Looks like we had some trouble here. We are checking this');
                console.log(p, copilotText);
            }
        } catch (e) {
            console.log(e);
            alert('Woops. Looks like we ran into some trouble there. Can you try again after some time?');
        } finally {
            setLoading(false);
        }

    }
    if (!expanded) {
        return <AsyncButton
            icon={CopilotIcon.default}
            className="global-copilot-button-header"
            onClick={async () => setExpanded((e) => !e)} title=" " />
    }

    return <>
        <AsyncButton
            icon={CopilotIcon.default}
            className="global-copilot-button-header"
            onClick={async () => setExpanded((e) => !e)} title="" />

        <div className='global-copilot'>
            <div className='gc-label'>Data Copilot at your service!</div>

            <textarea placeholder="only include temperature sensors and give me the total count" onKeyDown={handleKeyDown} disabled={loading} value={copilotText} onChange={(e) => setCopilotText(e.target.value)} />
            <div className="global-copilot-button"
                onClick={async () => await runCopilot()} title="Lets go!" >
                <FontAwesomeIcon icon={loading ? 'dot-circle' : 'arrow-up'} />
            </div>

        </div>
    </>;
};
